

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-select-shipping.xo-delete-shipping.route', ['squid', 'xo-select-shipping.xo-delete-shipping.directive']).factory('$DeleteShippingRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('DeleteShippingRoute', {
            name: 'deleteShipping',
            directive: 'xo-delete-shipping',
            titleContent: 'asideHeader.deleteShipping',
            trackingData: {
                fptiState: 'delete_shipping'
            },
            loginRequired: true,
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/delete-shipping/route.js
// module id = ./components/xo-member-components/src/select-shipping/delete-shipping/route.js
// module chunks = 1